import { EyeOutlined } from '@ant-design/icons';
import { type Procedimento } from '@framework/api-client/api/backoffice/schemas/procedimento.ts';
import { dossiersColumnsBase } from '@framework/common-web/schema/dossiers/table/dossierColumns.tsx';
import { generatePath, Link } from '@framework/ui/core/router/TypedRoute.tsx';
import { Space, Tooltip } from 'antd';
import {
  type ColumnGroupType,
  type ColumnsType,
  type ColumnType,
} from 'antd/es/table';

function getFrontofficeDossierColumns(
  isMobile: boolean,
): Record<string, ColumnGroupType<Procedimento> | ColumnType<Procedimento>> {
  return {
    ...dossiersColumnsBase,
    action: {
      key: 'action',
      align: 'right',
      render: (text, record) => (
        <Space>
          <Link
            title="Apri la pagina di dettaglio della pratica"
            to={generatePath('/pratiche/:id', { id: record.id! })}
          >
            <Tooltip title="Visualizza pratica">
              <EyeOutlined
                aria-hidden={!isMobile}
                aria-label="Visualizza pratica"
              />
            </Tooltip>
          </Link>
        </Space>
      ),
    },
  };
}

export function getDossiersColumns(
  isMobile: boolean | null,
): ColumnsType<Procedimento> {
  const frontofficeDossierColumns = getFrontofficeDossierColumns(!!isMobile);
  return [
    frontofficeDossierColumns.stato,
    frontofficeDossierColumns.tipoDomandaAvvio,
    frontofficeDossierColumns.numero,
    frontofficeDossierColumns.oggetto,
    frontofficeDossierColumns.numeroRichiesta,
    frontofficeDossierColumns.titolare,
    frontofficeDossierColumns.dataAvvio,
    frontofficeDossierColumns.dataUltimaModifica,
    frontofficeDossierColumns.action,
  ];
}
